<template>
  <div class="child-div">
    <van-sticky>
      <van-search
        v-model="soName"
        placeholder="请选择养老机构"
        readonly
        @click="soNameShow = true"
        left-icon="https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1697179014340.png"
      />
      <van-popup v-model="soNameShow" position="bottom">
        <van-picker
          show-toolbar
          :columns="serOrganList"
          value-key="Name"
          @confirm="soNameQr"
          @cancel="soNameShow = false"
        />
      </van-popup>
    </van-sticky>
    <div style="width: 95%; margin: auto">
      <div style="margin-top: 10px">
        <div class="boxStyle boxStyleBg" style="color: white">
          <!-- <div class="title">当天服务情况</div> -->
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <!-- <div class="nowTime" style="margin-left:10px;">当天服务情况</div> -->
            <div class="nowTime">
              {{ nowTime }}
            </div>
          </div>

          <div class="boxTopCount">
            <div class="boxTopCount01">
              <div class="money moneyBottom">
                {{ countLiveList.count1 }}
              </div>
              <div style="margin: 10px 0">试住</div>
            </div>
            <div class="boxTopCount01">
              <div class="money moneyBottom">
                {{ countLiveList.count2 }}
              </div>
              <div style="margin: 10px 0">入住</div>
            </div>
            <div class="boxTopCount01">
              <div class="money moneyBottom">
                {{ countLiveList.count3 }}
              </div>
              <div style="margin: 10px 0">退住</div>
            </div>
            <div class="boxTopCount01">
              <div class="money moneyBottom">
                {{ countLiveList.count4 }}
              </div>
              <div style="margin: 10px 0">助餐次数</div>
            </div>
          </div>
          <div class="boxTopCount" style="margin-top: 25px">
            <div class="boxTopCount01">
              <div class="money moneyBottom">
                {{ countMonthChangeLiveList.count1 }}
              </div>
              <div style="margin: 10px 0">当月试住</div>
            </div>
            <div class="boxTopCount01">
              <div class="money moneyBottom">
                {{ countMonthChangeLiveList.count2 }}
              </div>
              <div style="margin: 10px 0">当月入住</div>
            </div>
            <div class="boxTopCount01">
              <div class="money moneyBottom">
                {{ countMonthChangeLiveList.count3 }}
              </div>
              <div style="margin: 10px 0">当月退住</div>
            </div>
            <div class="boxTopCount01">
              <div class="money moneyBottom">
                {{ countMonthChangeLiveList.count4 }}
              </div>
              <div style="margin: 10px 0">当月助餐</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务趋势 -->
    <div class="boxStyle" style="background: white; padding: 10px; margin: 10px 2.5% 2.5% 2.5%">
      <div class="biankuang">
        <div class="biankuang1"></div>
        <div style="font-size: 16px; margin-left: 10px; line-height: 20px">
          服务趋势
        </div>
      </div>
      <div style="width: 100%; margin: 10px auto 0">
        <div id="qushi" style="width: 100%; height: 200px"></div>
      </div>
      <div class="biankuang">
        <div class="biankuang1"></div>
        <div style="font-size: 16px; margin-left: 10px; line-height: 20px">
          服务同比
        </div>
      </div>
      <div id="oldManTb" style="width: 100%; height: 200px"></div>

      <div class="biankuang" style="margin-top:10px ;">
        <div class="biankuang1"></div>
        <div style="font-size: 16px; margin-left: 10px; line-height: 20px">
          助餐情况
        </div>
      </div>
      <div style="width: 100%; margin: 10px auto 0">
        <div id="meal" style="width: 100%; height: 200px"></div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  countLiveStart,
  statisticsToday,
  getWxSerOrganList,
  WOTrendOfSO,
  WorkOrderTrendOfDay,
  countMonthChange,
  monthCount,
} from '@/api/oldman'
export default {
  data() {
    return {
      soName: '',
      soNameShow: false,
      active: 1,
      soId: '',
      nowTime: '', //当天日期
      list: {},
      statisticsToday: [],
      peopList: [],
      curWoNum: '',
      curStaffNum: '',
      curOndutyNum: '',
      statType: [
        { Id: 1, Name: '当天' },
        { Id: 0, Name: '全部' },
      ],
      countLiveList: [],
      serOrganList: [],
      countMonthChangeLiveList: [],
    }
  },
  mounted() {
    var now = new Date()
    var year = now.getFullYear()
    var month = now.getMonth() + 1
    var day = now.getDate()
    month = month.toString().padStart(2, '0') // 当小于10时，显示为01.02.03
    day = day.toString().padStart(2, '0') // 当小于10时，显示为01.02.03
    this.nowTime = `${year}-${month}-${day}` // 拼接日期

    this.tabsStyleXz = {
      'background-color': 'white',
      color: '#4393ff',
    }
    this.getWxSerOrganList()
  },
  methods: {
    // 获取养老机构
    getWxSerOrganList() {
      getWxSerOrganList({ serOrgTypeId: 3, name: '' }).then((res) => {
        if (res.data.code == 0) {
          this.serOrganList = res.data.data
          res.data.data.forEach((e) => {
            if (e.Name == '颐养居养老服务中心') {
              this.soId = e.SOId
              this.soName = e.Name
            }
          })

          this.getCountLiveStart()
          this.getWorkOrderTrend()
          this.getStatisticsToday()
        }
      })
    },
    // 选中养老机构
    soNameQr(val) {
      console.log(val)
      this.soId = val.SOId
      this.soName = val.Name
      // this.hzlist.HouserStatusName = val.Name;
      this.soNameShow = false

      this.getCountLiveStart()
      this.getWorkOrderTrend()
      this.getStatisticsToday()
    },
    // 各机构服务统计
    getCountLiveStart() {
      countLiveStart({ soId: this.soId }).then((res) => {
        console.log(res)
        if (res.data.code == 0) {
          this.countLiveList = res.data.data[0]
        }
      })
      // 当月变化
      countMonthChange({ soId: this.soId }).then((res) => {
        console.log(res)
        if (res.data.code == 0) {
          this.countMonthChangeLiveList = res.data.data[0]
        }
      })
    },

    getStatisticsToday() {
      WorkOrderTrendOfDay({ soId: this.soId }).then((res) => {
        if (res.data.code == 0) {
          var value = res.data.data
          // console.log(value)
          var todayNum = []
          var statTime = []
          var beforeYesterdayNum = []
          var yesterdayNum = []
          for (let i = 0; i < value.length; i++) {
            todayNum.push(value[i].TodayNum)
            statTime.push(value[i].StatTime)
            beforeYesterdayNum.push(value[i].BeforeYesterdayNum)
            yesterdayNum.push(value[i].YesterdayNum)
          }
          this.getOldManTb(todayNum, statTime, beforeYesterdayNum, yesterdayNum)
        }
      })
    },

    // 服务趋势
    getWorkOrderTrend() {
      WOTrendOfSO({ SOId: this.soId }).then((res) => {
        var list = res.data
        console.log(list)
        if (list.code == 0) {
          var StatDay = []
          var OrderCount = []
          //   console.log(list.data);
          list.data.forEach((a) => {
            if (a.SOId == this.soId) {
              a.Detail.forEach((b) => {
                StatDay.push(b.SOName)
                OrderCount.push(b.StatDate)
              })
            }
          })

          this.getTxTongJi(StatDay, OrderCount)
        }
      })
      // 助餐统计
      monthCount({ soId: this.soId }).then((res) => {
        var mealList = res.data
        console.log(mealList)
        if (mealList.code == 0) {
          var dayStr = []
          var dayCount = []
          var dayMoney = []
          mealList.data.forEach((a) => {
            dayStr.push(a.dayStr)
            dayCount.push(a.dayCount)
            dayMoney.push(a.dayMoney)
          })

          this.getMealStat(dayStr, dayCount, dayMoney)
        }
      })
    },
    getTxTongJi(StatDay, OrderCount) {
      // console.log(StatDay, OrderCount)
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('qushi'))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              backgroundColor: '#6a7985',
            },
          },
          textStyle: {
            color: 'black',
            fontStyle: 'normal',
            fontFamily: '微软雅黑',
            fontSize: 16,
          },
        },
        grid: {
          top: '11%',
          left: '1%',
          right: '1%',
          bottom: '8%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            axisLine: {
              //坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                color: '#f9f9f9',
              },
            },
            axisLabel: {
              //坐标轴刻度标签的相关设置
              interval: 0, //横轴信息全部显示
              rotate: 60, //60度角倾斜显示
              textStyle: {
                color: 'black',
                margin: 15,
              },
            },
            axisTick: {
              show: false,
            },
            data: StatDay,
          },
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            // max: 140,
            splitNumber: 7,
            splitLine: {
              show: true,
              lineStyle: {
                color: '#eee',
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#eee',
              },
            },
            axisLabel: {
              margin: 20,
              textStyle: {
                color: 'black',
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '服务次数:',
            type: 'line',
            smooth: true, //是否平滑曲线显示
            // 			symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            showAllSymbol: true,
            symbol: 'emptyCircle',
            lineStyle: {
              normal: {
                color: '#54bdff', // 线条颜色
              },
              borderColor: '#f0f',
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: 'black',
              },
            },
            itemStyle: {
              normal: {
                color: '#7099ed',
              },
            },

            areaStyle: {
              //区域填充样式
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgba(55, 148, 255,1)',
                    },
                    {
                      offset: 1,
                      color: 'rgba(55, 148, 255, 0)',
                    },
                  ],
                  false
                ),
                shadowColor: 'rgba(53,142,215, 0.9)', //阴影颜色
                shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
              },
            },
            data: OrderCount,
          },
        ],
      })
    },

    // 服务同比
    getOldManTb(todayNum, statTime, beforeYesterdayNum, yesterdayNum) {
      let myChart = this.$echarts.init(document.getElementById('oldManTb'))
      myChart.setOption({
        backgroundColor: 'rgba(255, 255, 255, 0.245)',
        tooltip: {
          //提示框组件
          trigger: 'axis',
          formatter: '{b}<br />{a0}: {c0}<br />{a1}: {c1}<br />{a2}: {c2}',
          axisPointer: {
            type: 'shadow',
            label: {
              backgroundColor: '#6a7985',
            },
          },
          textStyle: {
            color: 'black',
            fontStyle: 'normal',
            fontFamily: '微软雅黑',
            fontSize: 16,
          },
        },
        grid: {
          left: '1%',
          right: '4%',
          bottom: '10%',
          top: '15%',
          padding: '0 0 10 0',
          containLabel: true,
        },
        legend: {
          //图例组件，颜色和名字
          bottom: '-2%',
          itemGap: 26,
          itemWidth: 18,
          itemHeight: 10,
          data: [
            {
              name: '前天',
            },
            {
              name: '昨天',
            },
            {
              name: '今天',
            },
          ],
          textStyle: {
            color: 'black',
            fontStyle: 'normal',
            fontFamily: '微软雅黑',
            fontSize: 12,
          },
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true, //坐标轴两边留白
            data: ['7:30', '10:30', '13:30', '16:30', '19:30', '22:30'],
            axisLabel: {
              interval: 0, //横轴信息全部显示
              rotate: 30, //60度角倾斜显示
              textStyle: {
                color: '#000',
                fontSize: 12,
              },
            },
            axisLine: {
              lineStyle: {
                color: '#eee',
              },
            },
          },
          {
            axisPointer: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            position: 'bottom',
            offset: 20,
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#eee',
              },
            },
            axisLabel: {
              textStyle: {
                color: '#000',
                fontSize: 14,
              },
            },

            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,.1)',
              },
            },
          },
        ],
        series: [
          {
            name: '前天',
            type: 'bar',
            data: beforeYesterdayNum,
            barWidth: 10,
            barGap: 0, //柱间距离
            label: {
              //图形上的文本标签
              normal: {
                show: true,
                position: 'top',
                textStyle: {
                  color: '#c37dff',
                  fontStyle: 'normal',
                  fontFamily: '微软雅黑',
                  fontSize: 12,
                  fontWeight: 600,
                },
              },
            },
            itemStyle: {
              //图形样式
              normal: {
                color: '#c37dff',
              },
            },
          },
          {
            name: '昨天',
            type: 'bar',
            data: yesterdayNum,
            barWidth: 10,
            barGap: 0.5, //柱间距离
            label: {
              //图形上的文本标签
              normal: {
                show: true,
                position: 'top',

                lineHeight: 20,
                textStyle: {
                  color: '#d0a00e',
                  fontStyle: 'normal',
                  fontFamily: '微软雅黑',
                  fontSize: 12,
                  fontWeight: 600,
                },
              },
            },
            itemStyle: {
              //图形样式
              normal: {
                color: '#d0a00e',
              },
            },
          },
          {
            name: '今天',
            type: 'bar',
            data: todayNum,
            barWidth: 10,
            barGap: 0.5, //柱间距离
            label: {
              //图形上的文本标签
              normal: {
                show: true,
                position: 'top',
                lineHeight: 40,
                textStyle: {
                  color: '#33ccff',
                  fontStyle: 'normal',
                  fontFamily: '微软雅黑',
                  fontSize: 12,
                  fontWeight: 600,
                },
              },
            },
            itemStyle: {
              //图形样式
              normal: {
                color: '#33ccff',
              },
            },
          },
        ],
      })
    },

    // 助餐统计
    getMealStat(dayStr, dayCount, dayMoney) {
      console.log(dayStr, dayCount, dayMoney)
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('meal'))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              backgroundColor: '#6a7985',
            },
          },
          textStyle: {
            color: 'black',
            fontStyle: 'normal',
            fontFamily: '微软雅黑',
            fontSize: 16,
          },
        },
        grid: {
          top: '11%',
          left: '1%',
          right: '1%',
          bottom: '8%',
          containLabel: true,
        },
        legend: {
          //图例组件，颜色和名字
          bottom: '-2%',
          itemGap: 26,
          itemWidth: 18,
          itemHeight: 10,
          data: ['助餐次数', '助餐金额'],
          textStyle: {
            color: 'black',
            fontStyle: 'normal',
            fontFamily: '微软雅黑',
            fontSize: 12,
          },
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            axisLine: {
              //坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                color: '#f9f9f9',
              },
            },
            axisLabel: {
              //坐标轴刻度标签的相关设置
              interval: 0, //横轴信息全部显示
              rotate: 60, //60度角倾斜显示
              textStyle: {
                color: 'black',
                margin: 15,
              },
            },
            axisTick: {
              show: false,
            },
            data: dayStr,
          },
        ],
        yAxis: [
          {
            type: 'value',
            // min: 1,
            // max: 140,
            splitNumber: 7,
            splitLine: {
              show: true,
              lineStyle: {
                color: '#eee',
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#eee',
              },
            },
            axisLabel: {
              margin: 20,
              textStyle: {
                color: 'black',
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '助餐次数',
            type: 'line',
            smooth: true, //是否平滑曲线显示
            // 			symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            showAllSymbol: true,
            symbol: 'emptyCircle',
            symbolSize: 6,
            lineStyle: {
              normal: {
                color: '#54bdff', // 线条颜色
              },
              borderColor: '#f0f',
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: 'black',
              },
            },
            itemStyle: {
              normal: {
                color: '#7099ed',
              },
            },

            areaStyle: {
              //区域填充样式
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgba(55, 148, 255,1)',
                    },
                    {
                      offset: 1,
                      color: 'rgba(55, 148, 255, 0)',
                    },
                  ],
                  false
                ),
                shadowColor: 'rgba(53,142,215, 0.9)', //阴影颜色
                shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
              },
            },
            data: dayCount,
          },

          {
            name: '助餐金额',
            type: 'line',
            smooth: true, //是否平滑曲线显示
            // 			symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
            showAllSymbol: true,
            symbol: 'emptyCircle',
            symbolSize: 6,
            lineStyle: {
              normal: {
                color: '#d0a00e', // 线条颜色
              },
              borderColor: '#f0f',
            },
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: 'black',
              },
            },
            itemStyle: {
              normal: {
                color: '#d0a00e',
              },
            },

            areaStyle: {
              //区域填充样式
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: 'rgba(208, 160, 14,1)',
                    },
                    {
                      offset: 1,
                      color: 'rgba(208, 160, 14, 0)',
                    },
                  ],
                  false
                ),
                shadowColor: 'rgba(208, 160, 14, 0.9)', //阴影颜色
                shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
              },
            },
            data: dayMoney,
          },
        ],
      })
    },
  },
}
</script>
<style scoped>
/* pages/notice/notice.wxss */
.child-div {
  min-height: 100%;
  background-color: #f5f5f5;
  background-image: url(https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1710830956159.png) no-repeat center center;
  background-size: 100% 100%;
}
.tabsStyle {
  /* display: flex;
  justify-content: space-around; */
  background: #4393ff;
  /* padding: 10px; */
}
.tabsStyle {
}
.tabsStyle div {
  padding: 5px 10px;

  border-radius: 5px;
}
.boxStyleBg {
  background: url(https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1710830930874.png) no-repeat center center;
  background-size: 100% 100%;
  /* background: linear-gradient(to bottom, #ffb150 0%, #ea561d 100%); */
}
.nowTime {
  margin-top: 10px;
  margin-left: 10px;
  text-align: left;
  font-size: 14px;
}
.boxStyle {
  /* border: 1px solid red; */
  /* background: white; */
  padding: 5px;
  border-radius: 8px;
  /* margin-top: 10px; */
}
.moneyTop {
  margin-top: 5px;
  font-size: 18px;
  font-weight: 550;
}
.moneyBottom {
  font-weight: 550;
  font-size: 20px;
  margin-bottom: 5px;
}
.title {
  font-size: 16px;
  font-weight: 550;
  margin: 10px 10px 0 10px;
}

.boxTopCount01 {
  width: 33%;
  text-align: center;
  font-size: 14px;
}

.miaoshu {
  font-weight: 550;
  font-size: 14px;
  /* color:#ababab; */
}

.boxTopCount {
  display: flex;
  justify-content: space-between;
  margin: 15px 10px 0;
}

.biankuang {
  /* border-left: 4px solid #6182FA; */
  width: 95%;
  margin: 10rpx auto;
}

.biankuang1 {
  /* border-left: 4px solid #6182FA; */
  border: 2px solid #13a8ff;
  background-color: #13a8ff;
  width: 0;
  height: 17px;
  float: left;
  border-radius: 2px;
}

.image {
  width: 16px;
  height: 16px;
  margin-right: 14rpx;
}

.monthMaxCard {
  display: flex;
  justify-content: space-around;
}

.count {
  font-size: 18px;
  font-weight: 550;
  padding-top: 5px;
}
.tabclass .van-tabs__wrap .van-tabs__scroll {
  width: 95%;
  margin: auto !important;
}
.boxOldman {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.oldmanNum {
  margin: 5px 10px;
}
.oldmanBottom {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  font-weight: 550;
}
.oldmanBottomCount {
  padding-left: 10px;
  font-size: 18px;
}
.oldmanImg {
  margin-top: 5px;
}

.oldmanImg img {
  width: 33px;
  height: 33px;
}
.boxStyle01 {
  width: 29%;
  background-color: #edf8ff;
  /* display: flex; */
}
.boxStyle02 {
  width: 29%;
  background-color: #fef7ec;
}
.boxStyle03 {
  width: 29%;
  background-color: #edfbf5;
}
.parentClass01 {
  color: #00cb83 !important;
  font-size: 18px;
}

.parentClass02 {
  color: #feaa0d !important;
  font-size: 20px;
}

.parentClass03 {
  color: #6182fa !important;
  font-size: 18px;
}

.peopListBox {
  display: flex;
  border-bottom: 1px solid #eeeeee;
  padding: 15px;
}
.peopListBox:last-child {
  border-bottom: 1px solid #eeeeee00;
}
.peopListBox_Image {
  background-color: #d8d8d8;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  float: left;
  margin-right: 10px;
}

.peopListBox_Name {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #141414;
  padding-top: 5px;
}

.peopListBox_Content {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
  white-space: nowrap; /* 禁止换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出一行显示省略号 */
}

.peopListBox_jifen {
  height: 21px;
  font-size: 10px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
  padding-top: 5px;
}

.peopListBox_count {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #f83042;
}
</style>
